import React from 'react';
import { ShieldCheck, MapPin, Users, Lock, Sparkles } from 'lucide-react';

/**
 * TrustPanel — Reusable trust/value-props strip used on Login & Register pages.
 * Replaces the previous 'Demo accounts' block with meaningful B2B credibility signals.
 */
const DEFAULT_ITEMS = [
  { icon: ShieldCheck, text: 'GST-verified sellers only', color: 'text-[hsl(var(--verified))]' },
  { icon: MapPin, text: 'Local-first search across 50+ Indian cities', color: 'text-primary' },
  { icon: Users, text: 'Direct owner contact — no middlemen', color: 'text-primary' },
  { icon: Lock, text: 'Secure payments via Razorpay', color: 'text-foreground' },
];

export const TrustPanel = ({ heading = 'Join 500+ verified Indian industrial businesses', items = DEFAULT_ITEMS, className = '' }) => (
  <div
    className={`mt-6 rounded-lg border border-primary/20 bg-primary/5 p-4 ${className}`}
    data-testid='trust-panel'
  >
    <div className='flex items-start gap-2 mb-3'>
      <Sparkles className='h-4 w-4 text-primary shrink-0 mt-0.5' />
      <div className='text-sm font-semibold text-foreground leading-snug'>{heading}</div>
    </div>
    <ul className='space-y-2'>
      {items.map(({ icon: Icon, text, color }, i) => (
        <li key={i} className='flex items-start gap-2 text-xs text-muted-foreground'>
          <Icon className={`h-3.5 w-3.5 shrink-0 mt-0.5 ${color || 'text-primary'}`} />
          <span>{text}</span>
        </li>
      ))}
    </ul>
  </div>
);

export default TrustPanel;
